import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const PricingCard: React.FC<{
  title: string;
  price: string;
  features: string[];
}> = ({ title, price, features }) => (
  <div className="relative flex flex-col p-8 rounded-2xl border border-mira-accent/30 bg-mira-surface shadow-[0_0_30px_rgba(26,140,255,0.1)] hover:shadow-[0_0_50px_rgba(26,140,255,0.25)] hover:border-mira-accent/60 transition-all duration-300 hover:-translate-y-2 group h-full">
    
    <div className="absolute inset-0 bg-gradient-to-b from-mira-accent/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

    <div className="relative z-10 flex flex-col h-full">
      <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-mira-accent transition-colors drop-shadow-[0_0_5px_rgba(0,0,0,0.5)]">
        {title}
      </h3>

      {/* PRICE DISPLAY */}
      <div className="mb-8">
        <span className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300 tracking-tight">
          {price}
        </span>

        {/* Conditional labels */}
        {title === "Desarrollo Chatbot" && (
          <span className="text-gray-500 text-sm ml-2">pago único</span>
        )}

        {title === "Mantenimiento" && (
          <span className="text-gray-500 text-sm ml-2">al mes</span>
        )}
      </div>

      <ul className="space-y-4 mb-8 flex-1">
        {features.map((feature, idx) => (
          <li key={idx} className="flex items-start">
            <Check className="w-5 h-5 text-mira-accent mr-3 shrink-0 drop-shadow-[0_0_5px_rgba(26,140,255,0.8)]" />
            <span className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">
              {feature}
            </span>
          </li>
        ))}
      </ul>

      <Link
        to="/contacto"
        className="block w-full py-4 px-6 text-center rounded-lg font-bold bg-mira-accent text-mira-bg hover:bg-blue-400 shadow-[0_0_15px_rgba(26,140,255,0.4)] hover:shadow-[0_0_25px_rgba(26,140,255,0.6)] transition-all transform active:scale-95"
      >
        Contactar
      </Link>
    </div>
  </div>
);

const Pricing: React.FC = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-mira-accent/5 rounded-full blur-[100px] -z-10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4 text-white tracking-tight">
            <span className="text-mira-accent drop-shadow-[0_0_10px_rgba(26,140,255,0.4)]">
              Planes
            </span>{" "}
            Transparentes
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto font-medium">
            Inversión clara para digitalizar tu negocio. Sin costos ocultos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch max-w-5xl mx-auto">
          
          {/* PLAN 1 */}
          <PricingCard
            title="Desarrollo Chatbot"
            price="Desde $400 USD"
            features={[
              "Diseño de flujos conversacionales",
              "Integración WhatsApp Business API",
              "Configuración inicial",
              "Panel de administración básico",
              "Conexión con Google Sheets"
            ]}
          />

          {/* PLAN 2 */}
          <PricingCard
            title="Mantenimiento"
            price="Desde $40 USD"
            features={[
              "Mantenimiento mensual",
              "Ajustes en flujos existentes",
              "Optimización de respuestas AI",
              "Monitoreo de actividad 24/7",
              "Soporte prioritario"
            ]}
          />

        </div>
      </div>
    </section>
  );
};

export default Pricing;
